import {
	DndContext,
	DragEndEvent,
	DragOverlay,
	PointerSensor,
	TouchSensor,
	closestCenter,
	useSensor,
	useSensors,
} from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	styled,
} from '@mui/material';
import SortableArticlesItem from './SortableArticlesItem';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

interface DndArticleListSectionProps {
	meditationItems: any;
	dictDetails: any;
	agencyDetails: any;
	referralDetails: any;
	type: any;
	handleRepositionItem: (activeIndex: number, overIndex: number) => void;
}

export default function DndArticleListSection({
	meditationItems,
	handleRepositionItem,
	dictDetails,
	agencyDetails,
	referralDetails,
	type,
}: DndArticleListSectionProps) {
	const { t } = useTranslation();
	const { fieldType } = useParams();
	console.log(
		type,
		(type === 1 && dictDetails?.data.hasCode) ||
			(type === 2 && agencyDetails?.data.hasCode) ||
			(type === 3 && referralDetails?.data.hasCode) ||
			(type === 4 && dictDetails?.data.hasCode)
	);

	// for input methods detection
	const sensors = useSensors(useSensor(PointerSensor), useSensor(TouchSensor));

	// triggered when dragging ends
	const handleDragEnd = (event: DragEndEvent) => {
		const { active, over } = event;
		if (!over) return;

		const activeItem = meditationItems.find(
			(item: any) => item.id === active.id
		);
		const overItem = meditationItems.find((item: any) => item.id === over.id);

		if (!activeItem || !overItem) {
			return;
		}

		const activeIndex = meditationItems.findIndex(
			(item: any) => item.id === active.id
		);
		const overIndex = meditationItems.findIndex(
			(item: any) => item.id === over.id
		);

		if (activeIndex !== overIndex) {
			handleRepositionItem(activeIndex, overIndex);
		}
	};

	return (
		<DndContext
			sensors={sensors}
			collisionDetection={closestCenter}
			onDragEnd={handleDragEnd}
		>
			<SortableContext
				items={meditationItems.map((i: { id: any }) => i.id)}
				strategy={rectSortingStrategy}
			>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow
								sx={{
									backgroundColor: '#EEF1F6',
								}}
							>
								{(type === 1 && dictDetails?.data.hasCode) ||
								(type === 2 && agencyDetails?.data.hasCode) ||
								(type === 3 && referralDetails?.data.hasCode) ||
								(type === 4 && dictDetails?.data.hasCode) ? (
									<StyledTableCell>{t('field.code')}</StyledTableCell>
								) : (
									''
								)}

								<StyledTableCell>{t('field.en')}</StyledTableCell>
								{(type === 1 && dictDetails?.data.hasChinese) ||
								(type === 2 && agencyDetails?.data.hasChinese) ||
								(type === 3 && referralDetails?.data.hasChinese) ||
								(type === 4 && dictDetails?.data.hasChinese) ? (
									<StyledTableCell>{t('field.zh')}</StyledTableCell>
								) : (
									''
								)}

								{fieldType === 'nature' && (
									<StyledTableCell>
										{t('field.needEnterRiskLevel')}
									</StyledTableCell>
								)}
								{fieldType === 'nature' && (
									<StyledTableCell>
										{t('field.countMeetingIntervention')}
									</StyledTableCell>
								)}
								{fieldType === 'nature' && (
									<StyledTableCell>
										{t('field.countProgramMemberRenewalIntervention')}
									</StyledTableCell>
								)}

								<StyledTableCell>{t('field.lastUpdated')}</StyledTableCell>
								<StyledTableCell>{t('field.status')}</StyledTableCell>
								<StyledTableCell>{t('field.actionedBy')}</StyledTableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{meditationItems?.map((item: any) => (
								<SortableArticlesItem
									key={item.id}
									item={item}
									dictDetails={dictDetails}
									agencyDetails={agencyDetails}
									referralDetails={referralDetails}
									type={type}
								/>
							))}
						</TableBody>
					</Table>
				</TableContainer>
				<DragOverlay />
			</SortableContext>
		</DndContext>
	);
}

const StyledTableCell = styled(TableCell)({
	fontWeight: 'normal',
	minWidth: '100px',
});
